import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

import { UserForm } from './user.form';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractFormComponent } from '../../../../../shared/crud/component/form.component';
import { Observable } from 'rxjs';
import { ISelectOption } from '../../../../../shared/form/element/base-select/select-option.interface';

@Component({
  templateUrl: './form.component.html'
})
export class AdminUserFormComponent extends AbstractFormComponent implements OnInit, AfterViewInit {

  customers$: Observable<any>;

  roles: ISelectOption[] = [
    {
      value: 'MANAGER',
      label: 'Manager'
    },
    {
      value: 'OWNER',
      label: 'Owner'
    },
    {
      value: 'ADMIN',
      label: 'Admin'
    },
    {
      value: 'PHOTOGRAPHER',
      label: 'Photographer'
    }
  ];

  @ViewChild('formModal', { static: false }) formModal: ModalDirective;

  constructor(formBuilder: UserForm,
              httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute) {
    super(formBuilder, httpClient, toastrService, router, route);
  }


  ngAfterViewInit() {
    super.ngAfterViewInit();

    if (this.formMode === 'update') {
      this.populate().subscribe();
    }
  }

  ngOnInit() {
    super.ngOnInit();

    this.customers$ = Observable.create((obs) => {
      this.httpClient.get<any>('/admin/customer', {
        params: {
          limit: '999'
        }
      })
        .subscribe(
          (response) => {
            obs.next(response.rows.map((row) => {
              return <ISelectOption>{ value: row.id, label: row.name };
            }));
            obs.complete();

          },
          (error: any) => {
            obs.error(error);
            obs.complete();
          }
        );
    });
  }

  protected getUrl(): string {
    return `/admin/user${this.route.snapshot.params.id ? '/' + this.route.snapshot.params.id : ''}`;
  }

  protected onSubmit(response: any): void {
    this.toastrService.success('Saved');
    this.back();
  }

  back() {
    this.router.navigate([ '../' ], { relativeTo: this.route });
  }
}
